module.exports = __webpack_public_path__ + "static/media/delete.273719da.svg";